import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBayiProfil_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBayiProfil_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  DealersById: any[];
  DealersById_dummy: any[];
  KUserProfileById: any[];
  KUserProfileById_dummy: any[];
  CitiesByDealerID: any[];
  CitiesByDealerID_dummy: any[];
  GoalsByDelaerId: any[];
  GoalsByDelaerId_dummy: any[];
  GetBadgeByName: any[];
  GetBadgeByName_dummy: any[];
  isCompbayiprofil_39753AuthorizationVisible: "visible" | "hidden";
}

export class BayiProfil_ScreenBase extends React.PureComponent<
  IBayiProfil_ScreenProps,
  any
> {
  bayiprofil_620770_value_kuikaFlexGridRef: React.RefObject<any>;
  bayiprofil_756067_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "112e9f35-4020-44d4-a8d1-af841a31f08d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 780889, PropertyName: "value", Value: "Bayi Profil" },
        { Id: 733288, PropertyName: "value", Value: "Belgeler" },
        { Id: 555001, PropertyName: "value", Value: "Adres Bilgileri" },
        { Id: 311680, PropertyName: "value", Value: "Genel Bilgiler" },
        { Id: 357667, PropertyName: "value", Value: "İlgilendiği Şehirler" },
        {
          Id: 620770,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 715439, PropertyName: "value", Value: "[datafield:name]" },
        { Id: 785875, PropertyName: "value", Value: "Hedefler" },
        { Id: 867874, PropertyName: "title", Value: "Title" },
        { Id: 5468, PropertyName: "value", Value: "[datafield:name]" },
        { Id: 46930, PropertyName: "value", Value: "[datafield:validyear]" },
        { Id: 292683, PropertyName: "value", Value: "[datafield:description]" },
        { Id: 207423, PropertyName: "value", Value: "[datafield:typename]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.bayiprofil_620770_value_kuikaFlexGridRef = React.createRef();
    this.bayiprofil_756067_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      DealersById: [],
      KUserProfileById: [],
      CitiesByDealerID: [],
      GoalsByDelaerId: [],
      GetBadgeByName: [],
      isCompbayiprofil_39753AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bayiprofil", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BayiProfilPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompbayiprofil_39753AuthorizationVisible",
      [
        "6ffd9fd2-9d35-4a3c-4405-1c4e97bb6e8c",
        "8a9da0e3-1949-3a4c-17e4-e92540dae15f",
        "Admin",
        "Bayi",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("bayiprofil", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bayiprofil", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BayiProfilPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BayiProfilPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealersById !== undefined
            ? stateVars.DealersById?.length > 0
              ? stateVars.DealersById[0].userID
              : null
            : this.state.DealersById?.length > 0
            ? this.state.DealersById[0].userID
            : null
        ),
        "Guid"
      ),
      DealerID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
      DealerID_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
      DelaerID_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BayiProfil/BayiProfilPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DealersById = result?.data.dealersById;
    formVars.bayiprofil_963734_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].dealerName
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].dealerName
        : null
    );
    formVars.bayiprofil_107105_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].addressText
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].addressText
        : null
    );
    stateVars.KUserProfileById = result?.data.kUserProfileById;
    formVars.bayiprofil_648719_value = ReactSystemFunctions.toString(
      this,
      stateVars.KUserProfileById !== undefined
        ? stateVars.KUserProfileById?.length > 0
          ? stateVars.KUserProfileById[0].fullName
          : null
        : this.state.KUserProfileById?.length > 0
        ? this.state.KUserProfileById[0].fullName
        : null
    );
    formVars.bayiprofil_768324_value = ReactSystemFunctions.toString(
      this,
      stateVars.KUserProfileById !== undefined
        ? stateVars.KUserProfileById?.length > 0
          ? stateVars.KUserProfileById[0].username
          : null
        : this.state.KUserProfileById?.length > 0
        ? this.state.KUserProfileById[0].username
        : null
    );
    formVars.bayiprofil_158235_value = ReactSystemFunctions.toString(
      this,
      stateVars.KUserProfileById !== undefined
        ? stateVars.KUserProfileById?.length > 0
          ? stateVars.KUserProfileById[0].phoneNumber
          : null
        : this.state.KUserProfileById?.length > 0
        ? this.state.KUserProfileById[0].phoneNumber
        : null
    );
    stateVars.CitiesByDealerID = result?.data.citiesByDealerID;

    stateVars.GoalsByDelaerId = result?.data.goalsByDelaerId;

    stateVars.GetBadgeByName = result?.data.getBadgeByName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BayiProfilPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BayiProfilPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bayiprofil_963734_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].dealerName
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].dealerName
        : null
    );

    formVars.bayiprofil_648719_value = ReactSystemFunctions.toString(
      this,
      stateVars.KUserProfileById !== undefined
        ? stateVars.KUserProfileById?.length > 0
          ? stateVars.KUserProfileById[0].fullName
          : null
        : this.state.KUserProfileById?.length > 0
        ? this.state.KUserProfileById[0].fullName
        : null
    );

    formVars.bayiprofil_768324_value = ReactSystemFunctions.toString(
      this,
      stateVars.KUserProfileById !== undefined
        ? stateVars.KUserProfileById?.length > 0
          ? stateVars.KUserProfileById[0].username
          : null
        : this.state.KUserProfileById?.length > 0
        ? this.state.KUserProfileById[0].username
        : null
    );

    formVars.bayiprofil_158235_value = ReactSystemFunctions.toString(
      this,
      stateVars.KUserProfileById !== undefined
        ? stateVars.KUserProfileById?.length > 0
          ? stateVars.KUserProfileById[0].phoneNumber
          : null
        : this.state.KUserProfileById?.length > 0
        ? this.state.KUserProfileById[0].phoneNumber
        : null
    );

    formVars.bayiprofil_107105_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].addressText
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].addressText
        : null
    );

    stateVars.dataSource_620770 =
      stateVars.CitiesByDealerID ?? this.state.CitiesByDealerID;

    stateVars.dataSource_756067 =
      stateVars.GoalsByDelaerId ?? this.state.GoalsByDelaerId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BayiProfilComponent_15045_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiProfilComponent_952788_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiProfilComponent_39753_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BayiTanim",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiProfil",
      "BayiTanim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiProfilComponent_619079_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BayiBelgeList",
      "DealerID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiProfil",
      "BayiBelgeList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiProfilComponent_858049_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "HedefGerceklesmeOran",
      "GoalD",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "bayiprofil_756067_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "HedefGerceklesmeOran",
      "DealerID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.DealerID ?? this.props.screenInputs.dealerid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiProfil",
      "HedefGerceklesmeOran",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BayiProfilPageInit();
    }
  }
}
